import type { EntityWidgetProps } from "@/other/constants/EntityManagerConfig";
import { MarketingProvider, useMarketingContext } from "./context/MarketingContext";
import { MarketingAssetsContent } from "./components/MarketingAssetsContent";
import { DashboardCard } from "@/modern/components/dashboard-card";
import { CardTitle } from "@/modern/components/ui/card";
import { Button } from "@/modern/components/ui/button-shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";
import { ButtonGroup } from "@/modern/components/ui/button-group";
import { Expand } from "lucide-react";
import { useSwivuBryntumContext } from "@/react/hooks/useSwivuBryntumContext";
import { EDITOR_KEYS } from "@/other/constants/EditorKeys";

const MarketingAssetsViewContent = ({ onClose, headerTitle }: { onClose?: () => void; headerTitle?: string }) => {
  const { totalApproved, entityRecord } = useMarketingContext();
  const { editorHandler } = useSwivuBryntumContext();

  const handleOpenEditor = () => {
    editorHandler.openEditor(
      EDITOR_KEYS.marketingAssetEditor,
      // @ts-expect-error - null recordIdObj when using by: "recordType"
      null,
      { entityRecord },
      { by: "recordType", useExisting: true },
    );
  };

  return (
    <DashboardCard
      onClose={onClose}
      cardContentClassName="h-full flex flex-col p-0"
      header={
        <div className="flex items-center justify-between w-full">
          <CardTitle className="text-base flex items-center truncate min-w-0">
            <span className="truncate">{headerTitle ?? "Marketing Assets"}</span>
          </CardTitle>
          <div className="flex items-center gap-2">
            {totalApproved > 0 && (
              <span className="inline-flex items-center justify-center px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 text-xs font-semibold">
                {totalApproved} promoted
              </span>
            )}
            {totalApproved > 0 && (
              <ButtonGroup>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button variant="entityHeader" size="icon" onClick={handleOpenEditor}>
                      <Expand className="size-4" />
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>View marketing assets</TooltipContent>
                </Tooltip>
              </ButtonGroup>
            )}
          </div>
        </div>
      }
    >
      <MarketingAssetsContent />
    </DashboardCard>
  );
};

export const MarketingAssetsView = ({ record, onClose, headerTitle }: EntityWidgetProps) => {
  return (
    <MarketingProvider entityRecord={record}>
      <MarketingAssetsViewContent onClose={onClose} headerTitle={headerTitle} />
    </MarketingProvider>
  );
};
